var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyFirstPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb237"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 186,
    x2: 326.228,
    xlinkHref: "#lg1",
    y1: 354.229,
    y2: 354.229
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 543.001,
    xlinkHref: "#lg1",
    y1: 198.082,
    y2: 198.082
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -81.333,
    x2: 310.908,
    xlinkHref: "#lg1",
    y1: 82.885,
    y2: 82.885
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -66.524,
    x2: 334.4,
    xlinkHref: "#lg1",
    y1: 220.359,
    y2: 220.359
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 185,
    x2: 477.159,
    y1: 198.082,
    y2: 198.082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb237"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.09,
    x2: 440.989,
    xlinkHref: "#lg1",
    y1: 167.86,
    y2: 167.86
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.146,
    x2: 292.48,
    y1: 162.587,
    y2: 162.587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#fb2b3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41926"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.343,
    x2: 391.851,
    xlinkHref: "#lg1",
    y1: 167.86,
    y2: 167.86
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbc56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#dc8758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e5528"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.078,
    x2: 417.922,
    xlinkHref: "#lg2",
    y1: 444.316,
    y2: 444.316
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.65,
    x2: 386.424,
    xlinkHref: "#lg2",
    y1: 444.315,
    y2: 444.315
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.569,
    x2: 361.431,
    y1: 444.316,
    y2: 444.316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e6f5"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.146,
    x2: 370.194,
    y1: 444.316,
    y2: 444.316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1ceeb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m206.792 306.022h96.416v96.416h-96.416z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 335.719c-57.506 0-113.216-13.499-156.867-38.012-46.132-25.906-76.059-62.497-84.27-103.035l-12.66-62.51c-3.578-17.667.914-35.804 12.325-49.759 11.412-13.955 28.296-21.959 46.323-21.959h390.298c18.027 0 34.911 8.004 46.323 21.959 11.411 13.955 15.903 32.091 12.325 49.759l-12.66 62.51c-8.211 40.538-38.138 77.13-84.27 103.035-43.651 24.513-99.361 38.012-156.867 38.012zm-195.149-230.393c-6.17 0-9.903 3.439-11.579 5.489s-4.306 6.391-3.081 12.437l12.66 62.511c5.578 27.54 27.689 53.399 62.257 72.811 37.05 20.806 84.955 32.264 134.891 32.264s97.841-11.458 134.891-32.264c34.569-19.413 56.679-45.271 62.257-72.812l12.66-62.51c1.225-6.047-1.405-10.388-3.081-12.438s-5.41-5.489-11.579-5.489h-390.296z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.951 60.444 5.808 44.882h308.46l5.808-44.882z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 290.838c-4.185 0-8.352-.24-12.506-.24-.066 0-.131-.001-.197-.001.066-.002.132-.003.198-.006-45.382-1.746-88.441-12.954-122.386-32.016-34.569-19.413-56.679-45.271-62.257-72.812l-12.66-62.511c-1.225-6.046 1.405-10.388 3.081-12.437 1.676-2.05 5.41-5.489 11.579-5.489h-25.012c-6.17 0-9.903 3.439-11.579 5.489s-4.306 6.391-3.081 12.437l12.66 62.511c5.578 27.541 27.689 53.399 62.257 72.812.04.022.079.045.119.067 7.453 4.178 13.987 9.843 18.899 16.835 18.056 25.701 44.37 44.964 74.859 54.19 16.447 3.07 33.418 5.005 50.641 5.727 42.567-2.872 80.379-24.651 104.497-57.472-27.473 8.438-57.895 12.916-89.112 12.916z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.472 82.403c-11.412-13.955-28.296-21.959-46.323-21.959h-25.011c18.027 0 34.911 8.004 46.323 21.959 11.411 13.955 15.903 32.091 12.325 49.759l-12.66 62.51c-8.211 40.538-38.138 77.13-84.27 103.035-40.478 22.731-91.327 35.983-144.361 37.791 4.157.142 8.326.222 12.505.222 57.506 0 113.216-13.5 156.867-38.012 46.132-25.906 76.059-62.497 84.27-103.035l12.66-62.51c3.579-17.669-.913-35.805-12.325-49.76z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 335.719c-71.155 0-131.251-52.82-140.383-123.387l-22.237-171.843c-2.778-21.467 13.941-40.489 35.587-40.489h254.065c21.647 0 38.365 19.022 35.587 40.489l-22.237 171.843c-9.131 70.567-69.227 123.387-140.382 123.387z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.651 82.885c-2.392 0-4.566.435-6.306 1.522l-28.706 17.397c-4.349 2.609-6.307 6.959-6.307 11.525 0 6.741 4.35 13.483 10.656 13.483 1.522 0 3.479-.436 5.437-1.74l6.307-3.914v110.691c0 6.959 8.481 10.438 16.962 10.438s16.962-3.479 16.962-10.438v-138.308c.001-6.524-8.046-10.656-15.005-10.656z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.033 0h-40.02c21.647 0 38.365 19.022 35.587 40.489l-22.237 171.843c-8.261 63.84-58.235 113.153-120.373 121.974 6.547.929 13.228 1.413 20.01 1.413 71.155 0 131.251-52.82 140.382-123.387l22.238-171.843c2.778-21.467-13.941-40.489-35.587-40.489z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.804 510h-291.608c-9.454 0-17.118-7.664-17.118-17.118v-97.132c0-9.454 7.664-17.118 17.118-17.118h291.608c9.454 0 17.118 7.664 17.118 17.118v97.132c0 9.454-7.664 17.118-17.118 17.118z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.804 378.631h-40.02c9.454 0 17.118 7.664 17.118 17.118v97.132c0 9.454-7.664 17.118-17.118 17.118h40.02c9.454 0 17.118-7.664 17.118-17.118v-97.132c0-9.454-7.664-17.118-17.118-17.118z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.703 491.351h-179.406c-9.239 0-16.728-7.49-16.728-16.728v-60.615c0-9.239 7.49-16.728 16.728-16.728h179.405c9.239 0 16.728 7.49 16.728 16.728v60.615c.001 9.239-7.489 16.728-16.727 16.728z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.703 397.28h-40.02c9.239 0 16.728 7.49 16.728 16.728v60.615c0 9.239-7.49 16.728-16.728 16.728h40.02c9.239 0 16.728-7.49 16.728-16.728v-60.615c0-9.239-7.49-16.728-16.728-16.728z",
    fill: "url(#SVGID_12_)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFirstPlace);
export default __webpack_public_path__ + "static/media/trophy-first-place.a66b1bebc92966f109019daafec83c0d.svg";
export { ForwardRef as ReactComponent };